import { useSelector } from 'core/common/hooks';
import { getOrderId } from '../store/selectors';

export const useOrder = () => {
  const orderId = useSelector(getOrderId);

  return { orderId };
};
